import {CompaniesImportTypeEnum} from '../../../../../../service/companies-import/companies-import-type';

import {ProgressTranslationType} from './progress/feed-progress';

export enum FeedFormKeyEnum {
    SourceUrl = 'sourceUrl',
    Format = 'format',
    AllowedBrands = 'allowedBrands',
    SendResultsToEmail = 'sendResultsToEmail',
    EmailsForSendResults = 'emailsForSendResults',
}

export type FeedFormType = {
    [FeedFormKeyEnum.SourceUrl]: string;
    [FeedFormKeyEnum.Format]: CompaniesImportTypeEnum;
    [FeedFormKeyEnum.AllowedBrands]: Array<{brandId: number; brandCode: string}>;
    [FeedFormKeyEnum.SendResultsToEmail]?: boolean;
    [FeedFormKeyEnum.EmailsForSendResults]?: Array<string>;
};

export enum FeedFormTabEnum {
    Link = 'link',
    File = 'file',
}

export type FeedFormTranslationType = 'submitButtonLabel' | ProgressTranslationType;
